import React from 'react'
import { Link } from 'react-router-dom'
import { Anchor } from 'grommet'

export const LinkAnchor = ({ to, ...props }) => (
  <Link to={to}>
    <Anchor as="span" {...props} />
  </Link>
)
